import { isExperimentEnabled } from '@atlaskit/platform-feature-experiments/is-experiment-enabled';

export const HEARTBEAT_V1_ENDPOINT = '/gateway/api/session/heartbeat';
export const HEARTBEAT_V2_ENDPOINT = '/gateway/api/v2/session/heartbeat';

export const getDefaultHeartbeatEndpoint = (): string =>
	isExperimentEnabled('id-kirby-heartbeat-v2-endpoint')
		? HEARTBEAT_V2_ENDPOINT
		: HEARTBEAT_V1_ENDPOINT;

export const DEFAULT_IDLE_TIME: number = 60 * 1000; // 60 seconds

export const INTERVAL_TIME: number = 10 * 1000; // 10 seconds
